import { filterXY } from 'ml-signal-processing';
import { xMinMaxValues, xyCheck } from 'ml-spectra-processing';
/**
 *
 * @private
 * @param input
 * @param [options={}]
 */
export function getNormalized(input, options = {}) {
    xyCheck(input);
    let { filters = [] } = options;
    const { from = input.x[0], to = input.x.at(-1), numberOfPoints = 1024, applyRangeSelectionFirst = false, exclusions = [], } = options;
    filters = structuredClone(filters);
    const equallySpacedFilter = {
        name: 'equallySpaced',
        options: {
            from,
            to,
            numberOfPoints,
            exclusions,
        },
    };
    if (applyRangeSelectionFirst) {
        filters.unshift(equallySpacedFilter);
    }
    else {
        filters.push(equallySpacedFilter);
    }
    const output = filterXY(input, filters).data;
    const allowedBoundary = {
        x: {
            min: output.x[0],
            max: output.x.at(-1),
        },
        y: xMinMaxValues(output.y),
    };
    return {
        data: output,
        allowedBoundary,
    };
}
//# sourceMappingURL=getNormalized.js.map